import "./App.css";
import { BrowserRouter, Route, Router, Routes } from "react-router-dom";
import ScrollToTop from "./utils/ScrollToTopUtils";
import RoleProtectedRoute from "./routes/RoleProtectedRoute";

import WebsiteLayout from "./layout/website/WebsiteLayout";
import Registration from "./pages/website/Registration";

import Login from "./pages/admin/Login";
import AdminLayout from "./layout/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import SelectConstituency from "./pages/website/SelectConstituency";
import WebsiteLogin from "./pages/website/Login";


import VerifyOtp from "./pages/website/VerifyOtp";
import { ToastContainer } from "react-toastify";

import AdminPublicRoute from "./routes/AdminPublicRoute";
import AdminPrivateRoute from "./routes/AdminPrivateRoute";
import BrandingKit from "./pages/admin/brandingkit/BrandingKit";
import ComingSoon from "./pages/admin/ComingSoon";
import RegistrationList from "./pages/admin/registration/List";
import MPList from "./pages/admin/mp/List";

import MembersList from "./pages/admin/members/List";

import GameCalendarList from "./pages/admin/gamecalendar/List";
import Register from "./pages/admin/Register";
import GameList from "./pages/website/GameList";
import MyProfile from "./pages/admin/users/MyProfile";
import ChangePassword from "./pages/admin/users/ChangePassword";
import SportList from "./pages/admin/sports/List";

import SopList from "./pages/admin/sopguide/List";
import SopGuide from "./pages/admin/sopguide/Detail";
import BrandingList from "./pages/admin/brandingkit/List";
import Analytics from "./pages/admin/Analytics";
import Media from "./pages/admin/Media/Media";

import ForgotPassword from './pages/admin/ForgotPassword';
import HelpCenter from "./pages/admin/HelpCenter";
import UserGuide from "./pages/admin/UserGuide";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Website Routes */}
        <Route path="/">
          <Route element={<WebsiteLayout />}>
            <Route index element={<SelectConstituency />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/login" element={<WebsiteLogin />} />
            <Route path="/game-list" element={<GameList />} />
            <Route path="/verify-otp" element={<VerifyOtp />} />
          </Route>
        </Route>

        {/* Admin Routes */}
        <Route element={<AdminPublicRoute />}>
          <Route path="/admin" element={<Login />} />
          <Route path="/admin/register" element={<Register />} />
          <Route path="/admin/forgot-password" element={<ForgotPassword />} />
        </Route>

        <Route element={<AdminPrivateRoute />}>
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="dashboard" element={<Dashboard />} />

            <Route path="sop-guide">
              <Route index element={<SopGuide />} />
              <Route path="list" element={<RoleProtectedRoute><SopList /></RoleProtectedRoute>} />
            </Route>

            <Route path="branding-kit">
              <Route index element={<BrandingKit />} />
              <Route path=":id" element={<BrandingKit />} />
              <Route path="list" element={<RoleProtectedRoute><BrandingList /></RoleProtectedRoute>} />
            </Route>

            
            <Route path="registrations" element={<RoleProtectedRoute><RegistrationList /></RoleProtectedRoute>} />

            <Route path="mp" element={<RoleProtectedRoute><MPList /></RoleProtectedRoute>} />
            
            <Route path="members" element={<RoleProtectedRoute><MembersList /></RoleProtectedRoute>} />
            
            <Route path="game-calendar" element={<RoleProtectedRoute><GameCalendarList /></RoleProtectedRoute>} />
            <Route path="sports" element={<RoleProtectedRoute><SportList /></RoleProtectedRoute>} />
            <Route path="game-selection" element={<RoleProtectedRoute><SportList /></RoleProtectedRoute>} />
            
            <Route path="analytics" element={<RoleProtectedRoute><Analytics /></RoleProtectedRoute>} />
            <Route path="my-profile" element={<MyProfile />} />
            <Route path="change-password" element={<ChangePassword />} />

            <Route path="settings" element={<ComingSoon />} />
            <Route path="user-guide" element={<UserGuide />} />
            <Route path="help-centre" element={<HelpCenter />} />
            <Route path="media" element={<Media />} />
          </Route>
        </Route>
      </Routes>

      <ToastContainer position="top-right" autoClose={3000} />
    </BrowserRouter>
  );
}

export default App;
